import { useParams } from 'react-router-dom';

import Dashboard from 'features/dashboard/Dashboard';
import useDashboardData from 'pages/dashboard/useDashboardData';

const DashboardPage = () => {
  const { projectId } = useParams();

  const { project, outputs } = useDashboardData(projectId);

  return <Dashboard projectId={projectId} project={project} outputs={outputs} />;
};

export default DashboardPage;
